import { apiFetch } from "@/api/client";

export interface AuthLogEntry {
  id: number;
  username: string;
  reply: string | null;
  authdate: string;
  is_failure: boolean;
}

export interface AuthLogListResponse {
  items: AuthLogEntry[];
  total: number;
  page: number;
  page_size: number;
}

export interface SystemLogResponse {
  unit: string;
  lines: number;
  content: string;
}

export const listAuthLog = (result: "all" | "success" | "failure", page: number) =>
  apiFetch<AuthLogListResponse>(`/logs/auth?result=${result}&page=${page}&page_size=50`);

export const fetchSystemLog = (lines: number) =>
  apiFetch<SystemLogResponse>(`/logs/system?lines=${lines}`);
